module.exports = __webpack_public_path__ + "static/media/reset.553724c5.svg";